/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createIngestManualChargePointConsumptionResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type IngestManualChargePointConsumptionResult, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { MultipartBody, serializeMultipartBody, type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /ingests/chargepoint-consumption/manual
 */
export interface ManualRequestBuilder extends BaseRequestBuilder<ManualRequestBuilder> {
    /**
     * IngestManualChargePointConsumption
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<IngestManualChargePointConsumptionResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: MultipartBody, requestConfiguration?: RequestConfiguration<ManualRequestBuilderPostQueryParameters> | undefined) : Promise<IngestManualChargePointConsumptionResult | undefined>;
    /**
     * IngestManualChargePointConsumption
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MultipartBody, requestConfiguration?: RequestConfiguration<ManualRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
/**
 * IngestManualChargePointConsumption
 */
export interface ManualRequestBuilderPostQueryParameters {
    verifyOnly?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const ManualRequestBuilderUriTemplate = "{+baseurl}/ingests/chargepoint-consumption/manual{?verifyOnly*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const ManualRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ManualRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createIngestManualChargePointConsumptionResultFromDiscriminatorValue,
        requestBodyContentType: "multipart/form-data",
        requestBodySerializer: serializeMultipartBody,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
